import React, {useEffect, useState} from "react";
import { getAuth, isSignInWithEmailLink, signInWithEmailLink } from "firebase/auth";
import { Navigate } from "react-router";

interface Props {
  redirectTo: string;
}

interface State {
  authState: number;
}

function RegisterResponse(props: Props) {
  const [authState, setAuthState] = useState<number>();

  useEffect(() => {(async () => {
    try {
      const auth = getAuth();
      if (isSignInWithEmailLink(auth, window.location.href)) {
        let email = window.localStorage.getItem('emailForSignIn');
        if (!email) {
          email = window.prompt('Please provide your email for confirmation');
        }
        let emailToSignInWith: string = '';
        if (email != null) {
          emailToSignInWith = email;
        }
        await signInWithEmailLink(auth, emailToSignInWith, window.location.href)
            .then((result) => {
              window.localStorage.removeItem('emailForSignIn');
              setAuthState(1)
            });
      } else {
        setAuthState(1);
      }
    } catch (e) {}
  })();
  }, []);

  return (
      <>
        {authState === 1 && <Navigate to={`/${props.redirectTo}`} />}
      </>
  )
}

export default RegisterResponse;
